import StoreLocatorView from "@/features/store-locator/views/StoreLocatorView.vue";

export default {
	path: '/store-locator',
	name: 'store-locator',
	props: true,
	meta:{
		standalone: true
	},
	component: StoreLocatorView
}
